/**
 * Mobile action bar — book, walk in, call.
 *
 * ─────────────────────────────────────────────────────────────
 * WHY IT LIVES IN SiteLayout, NOT THE HEADER
 * ─────────────────────────────────────────────────────────────
 * backdrop-filter on an ancestor makes that ancestor the containing block for
 * position:fixed descendants. The header carries backdrop-blur, so a fixed
 * element nested inside it clips to the header's box instead of the viewport
 * — the exact bug that broke the mobile drawer in 87acbfc. SiteLayout's
 * wrapper has no filter, so the bar anchors to the viewport from there.
 *
 * Route scoping comes free: SiteLayout wraps only the four marketing pages.
 * /kiosk, /tv, /w/* and /roster render their own shells and never see this.
 */

import { useCopy } from '../../content';
import { useShopConfig } from '../../hooks/useShopConfig';
import { Icon } from '../icons';

export default function MobileStickyBar() {
  const copy = useCopy();
  const c = copy.mobile.stickyBar;
  const { t, shop } = useShopConfig();

  return (
    <nav
      aria-label={t(c.label)}
      // env() keeps the row clear of the iOS home indicator.
      className="fixed inset-x-0 bottom-0 z-50 border-t border-edge-1 bg-white/95 px-4 pt-3 backdrop-blur-md lg:hidden"
      style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))' }}
    >
      {/* Two jobs, two buttons: booking (primary) and questions (Call).
          Walk-in signup stays dead — that is the in-shop tablet's job.
          60/40 split: the booking label is three words to Call's one, and
          equal halves left the primary looking cramped at 390px. */}
      <div className="flex gap-3">
        <a
          href={shop.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-[1.5] items-center justify-center gap-2 rounded-pill bg-navy py-3.5 font-newsreader text-[17px] text-white ring-1 ring-gold/40"
        >
          <Icon name="calendar" size={16} />
          {t(copy.home.hero.ctaPrimary)}
        </a>
        <a
          href={`tel:${shop.phone_e164}`}
          className="flex flex-1 items-center justify-center gap-2 rounded-pill border border-navy/25 bg-paper py-3.5 font-newsreader text-[17px] text-navy"
        >
          <Icon name="phone" size={16} />
          {t(c.call)}
        </a>
      </div>
    </nav>
  );
}
